import { useContext, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useToast } from "../context/ToastContext";
import { SALES_SUSPENDED } from "../config/salesSuspended";

// Bloqueia acesso direto às páginas de checkout enquanto as vendas
// estiverem suspensas. Usuário logado vai para a própria conta,
// visitante vai para a home.
const SalesSuspendedRoute = ({ children }) => {
  const { isAuthenticated, loadingAuth } = useContext(UserContext);
  const { toast } = useToast();
  const hasNotified = useRef(false);

  useEffect(() => {
    if (SALES_SUSPENDED && !loadingAuth && isAuthenticated && !hasNotified.current) {
      hasNotified.current = true;
      toast.info("As vendas estão temporariamente suspensas. Te trouxemos para sua conta.");
    }
  }, [loadingAuth, isAuthenticated, toast]);

  if (SALES_SUSPENDED) {
    if (loadingAuth) return null;
    return <Navigate to={isAuthenticated ? "/minha-conta" : "/"} replace />;
  }

  return children;
};

export default SalesSuspendedRoute;
